<template>
    <div>
        <hts-drawer
            v-model="visible"
            size="large"
            :rules="rulesAddBusiness"
            :submit="handleSubmit"
            :title="$t('labels.businessModule.add')"
            @close="closeOverSide">
            <hts-card :title="$t('labels.generalInformation')">
                <div
                    class="grid gap-4"
                    :class="columnClass">
                    <hts-form-input
                        v-model="dataAdd.name"
                        :label="$t('labels.businessModule.name')"
                        :required="true"
                        :color="props.color"
                        name="businessModule.name"
                        prop="businessModule.name" />
                    <hts-admincp-select-task
                        v-model="dataAdd.tasks"
                        required
                        multiple
                        :label="$t('labels.taskList')"
                        name="taskList"
                        prop="taskList"
                        key-id="_id"
                        key-label="name"
                        :filterable="true"
                        :clearable="true" />
                    <hts-form-input
                        v-model="dataAdd.description"
                        :label="$t('labels.description')"
                        :color="props.color"
                        name="description"
                        prop="description" />
                </div>
            </hts-card>
        </hts-drawer>

        <hts-modal
            :show="passDuplicateTask"
            :type="percentDuplicate !== 100 ? 'confirm' : ''"
            title=""
            :content="
                percentDuplicate !== 100
                    ? $t('labels.contentDuplicateTask', { business: nameBusinessDuplicate || '', name: dataAdd.name || '' })
                    : $t('labels.contentTheSameTask', { business: nameBusinessDuplicate || '', name: dataAdd.name || '' })
            "
            @close="passDuplicateTask = false"
            @confirm="handleSubmit" />
    </div>
</template>
<script setup lang="ts">
import { initAddBusiness, rulesAddBusiness } from '../imports/form'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const visible = ref(false)

const open = () => {
  visible.value = true
}

const emits = defineEmits(['close', 'refreshTables', 'newBusiness', 'update:show'])

const closeOverSide = () => {
  visible.value = false
}

const dataAdd = ref({ ...initAddBusiness })
const form = ref<HTMLFormElement>()
const passDuplicateTask = ref(false)
const nameBusinessDuplicate = ref('')
const percentDuplicate = ref(0)

const resetField = () => {
  dataAdd.value = { ...initAddBusiness }
  passDuplicateTask.value = false
  nameBusinessDuplicate.value = ''
  percentDuplicate.value = 0
}

const handleSubmit = async () => {
  const api = $urlAdmin.business.add
  const data = await $api(api, { body: { ...dataAdd.value, passDuplicateTask: passDuplicateTask.value } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    if (resData.data.duplicate) {
      passDuplicateTask.value = true
      nameBusinessDuplicate.value = resData.data.name
      percentDuplicate.value = resData.data.percent
    } else {
      emits('refreshTables')
      emits('newBusiness', resData.data)
      process.client && $toast().success($t('labels.addBusinessSuccess'))
      closeOverSide()
      resetField()
    }
  }
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

defineExpose({
  open
})
</script>
